export default __webpack_public_path__ + "static/taskdefinition12-4eebbe15104e88a03a88fdfc958eed57.png";